import React, { Component } from 'react';
import "./reserveABook.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import Select from 'react-select';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

class ReserveABook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addMember: false,
            filterModal: false,


            offset: 0,
            pageIndex: 1,
            limit: 10,
            accessDataList: false,
            successModal: false,

            // VARIABLES TO SELECT FACULTY
            selectedMemberIds: [],

            //VARIABLE TO GET MEMBERS LIST
            membersList: {},
            totalMembers: 0,
            accessMemberList: false,

            isFilterLoading: false,
            AccessionSeriesData: [],
            resourceSearchAccessionSeries: [],
            // selectedDate: "",
            loadingFilterAccessionSeries: false,
            isLoadingAddReserveBook: false,
            GetMultipleAccessionNumberList: [],
            searchMultipleAccessionNumber: [],
            searchAccessionNo: '',

            // filter fields
            filterAccessionSeriesData: [],
            filterSelectedAccessionSeries: [],
            filterAccessionNumberData: [],
            filterSelectedAccesionNumber: [],
            filterSearchAccessionNo: '',
            loadingFilterAccessionNumberData: false,
            loadingFilterAccessionSeriesData: false,
            filterStatus: [],

            // field validation
            accessionSeriesWarning: '',
            accessionNumberWarning: '',
            // expectedDateWarning: '',

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Accession Details", key: 'accessionDetails' },
                { name: "Resource Title", key: 'resourceTitle' },
                { name: "Resource Author", key: 'resourceAuthor' },
                { name: "Expected Date", key: 'expectedDate' },
                { name: "Added On", key: 'addedOn' },
                { name: "Status", key: 'status' },
                { name: "Queue Number", key: 'queueNumber' }
            ],
        }
    }

    componentDidMount() {
        this.library_getReserveResourceRequests();
        this.apiGetAccessionSeries();
        this.apiFilterGetAccessionSeries();

        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiGetAccessionSeries = async () => {
        this.setState({ loadingFilterAccessionSeries: true });

        let requestData = {
            "iid": config.institute_id,
            "iidArray": [config.institute_id]
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    AccessionSeriesData: formattedMembers,
                    filterAccessionSeriesData: formattedMembers,
                    loadingFilterAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingFilterAccessionSeries: false
                });
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES For Filter
    apiFilterGetAccessionSeries = async () => {
        this.setState({ loadingFilterAccessionSeriesData: true });

        let requestData = {
            "iid": config.institute_id,
            "iidArray": [config.institute_id]
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.seriestext,
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    filterAccessionSeriesData: formattedMembers,
                    loadingFilterAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingFilterAccessionSeriesData: false
                });
            }
        }
    }

    //API CALL METHOD TO GET MULTIPLE ACCESSION NUMBER
    getMultipleAccessionNoList = async () => {
        this.setState({ loadingAccessionNumberData: true });

        let accessionSeriesIdArray = []
        this.state.resourceSearchAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })


        let requestData = {
            "iid": config.institute_id,
            "accessionSeriesIdArr": accessionSeriesIdArray,
            "searchAccssionSeriesNo": this.state.searchAccessionNo,
            "pageIndex": 1,
            "limitPerPage": 10
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getMultipleAccessionNumber',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getMultipleAccessionNoList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.values(apiResult)?.map((data) => ({
                    value: data.resourceId,
                    label: data?.accessionNo,
                }));

                this.setState({
                    GetMultipleAccessionNumberList: formattedMembers,
                    loadingAccessionNumberData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession number list. Please try again later.',
                    loadingAccessionNumberData: false
                });
            }
        }
    }

    //API CALL METHOD TO GET MULTIPLE ACCESSION NUMBER for Filter
    getFilterMultipleAccessionNoList = async () => {
        this.setState({ loadingFilterAccessionNumberData: true });

        let filterSelectedAccessionSeries = []
        this.state.filterSelectedAccessionSeries?.map((item) => {
            filterSelectedAccessionSeries.push(item.value)
        })


        let requestData = {
            "iid": config.institute_id,
            "accessionSeriesIdArr": filterSelectedAccessionSeries,
            "searchAccssionSeriesNo": this.state.filterSearchAccessionNo,
            "pageIndex": 1,
            "limitPerPage": 10
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getMultipleAccessionNumber',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getFilterMultipleAccessionNoList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.values(apiResult)?.map((data) => ({
                    value: data.resourceId,
                    label: data?.accessionNo,
                }));

                this.setState({
                    filterAccessionNumberData: formattedMembers,
                    loadingFilterAccessionNumberData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession number list. Please try again later.',
                    loadingFilterAccessionNumberData: false
                });
            }
        }
    }

    // API CALL METHOD TO ADD Reserve A Book
    library_addReserveResourceRequest = async () => {
        let validData = true;

        if (this.state.resourceSearchAccessionSeries?.length == 0) {
            this.setState({
                accessionSeriesWarning: 'Please select accession series.'
            });
            validData = false;
        }

        if (this.state.searchMultipleAccessionNumber?.length == 0) {
            this.setState({
                accessionNumberWarning: 'Please select accession number.'
            });
            validData = false;
        }

        // if (!this.state.selectedDate) {
        //     this.setState({
        //         expectedDateWarning: 'Please select expected date.'
        //     });
        //     validData = false;
        // }

        if (validData) {

            let requestData = {
                "iid": config.institute_id,
                "userRole": config.account,
                "resourceCopyId": this.state.searchMultipleAccessionNumber?.value,
                "userId": config.faculty_id || config.studentId,
                // "expectedDate": this.state.selectedDate,
                "addedBy": config.faculty_id || config.studentId,
            };

            this.setState({ isLoadingAddReserveBook: true })

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_addReserveResourceRequest',
                requestData,
                '/api/library/library.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.library_addReserveResourceRequest()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;

                    if (apiResult.status == 'success') {

                        this.setState({
                            successModal: true,
                            successModalType: 'success',
                            successMessage: ReactHtmlParser(apiResult.message),
                            isLoadingAddReserveBook: false
                        }, () => {
                            this.closeAddMember();
                            this.library_getReserveResourceRequests();
                        });
                    } else {
                        this.setState({
                            successModal: true,
                            successModalType: 'warning',
                            successMessage: apiResult.message,
                            isLoadingAddReserveBook: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while reserving a book. Please try again later.',
                        isLoadingAddReserveBook: false
                    });
                }
            }
        }
    }

    // API CALL TO GET MEMBERS DATA LIST
    library_getReserveResourceRequests = async () => {

        this.setState({
            accessMemberList: true
        });

        let filterParameter = {
            "searchAccessionNumber": this.state.filterSelectedAccesionNumber?.label || "",
            "searchseries": this.state.filterSelectedAccessionSeries[0]?.value || ""
        }

        let requestData = {
            "iid": config.institute_id,
            "iidArray": [config.institute_id],
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "status": this.state.filterStatus?.value,
            "userRole": config.account,
            "userId": config.faculty_id || config.studentId,
            "filterParameter": filterParameter
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getReserveResourceRequests',
            requestData,
            "/api/library/library.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_getReserveResourceRequests();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        membersList: apiResult.data,
                        totalMembers: apiResult.totalRecords,
                        accessMemberList: false,
                        addMember: false
                    })
                }
                else {
                    this.setState({
                        membersList: {},
                        totalMembers: 0,
                        accessMemberList: false,

                    })
                }
            } else {
                this.setState({
                    membersList: {},
                    totalMembers: 0,
                    accessMemberList: false,

                })
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddMember = () => {
        // const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['membership'].find(access => access === 'add');

        // if (addGrantAccess !== undefined) {
        this.setState({
            addMember: true
        });
        // }
        // else {
        //     this.setState({
        //         successModal: true,
        //         successModalType: 'warning',
        //         successMessage: 'This operation is restricted by the Library admin.'
        //     });
        // }
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.library_getReserveResourceRequests();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
            selectedMemberIds: []
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.library_getReserveResourceRequests();
        });
    }

    // METHOD TO CLOSE ADD MEMBER MODAL
    closeAddMember = () => {
        this.setState({
            addMember: false,
            resourceSearchAccessionSeries: "",
            searchMultipleAccessionNumber: "",
            selectedDate: ""
        });
    }

    //METHOD TO VALIDATE TO Reserve A Book
    validateMembers = () => {
        this.library_addReserveResourceRequest();
    }

    // METHOD TO SELECT ALL MEMBERS
    selectAllMembers = (e) => {
        let memberSet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.membersList).length > 0) {
                Object.keys(this.state.membersList).map(employeeId => {
                    memberSet.add(employeeId);
                });
            }
        }

        this.setState({
            selectedMemberIds: Array.from(memberSet),
        });
    }

    // METHOD TO SELECT SINGLE EMPLOYEE
    selectSingleMember = (memberId) => {

        let selectedMemberIds = this.state.selectedMemberIds;

        if (selectedMemberIds.includes(memberId)) {
            selectedMemberIds = selectedMemberIds.filter(id => id != memberId);
        } else {
            selectedMemberIds.push(memberId);
        }

        this.setState({
            selectedMemberIds,
        });

    }

    // METHOD TO RETURN REGISTER NEW MEMBER
    returnRegisterNewMember = () => {
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addMember ? 'flex' : 'none' }}>
                <div id="addResourceDataContainer">
                    {/* header */}
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddMember()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '40%' }} className="col-11">Reserve A Book</h5>
                    </div>

                    {/* content */}
                    <div className='col-md-12 pl-4 pt-2'>
                        <div className='d-flex pb-3'>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Accession Series <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={Object.values(this.state.AccessionSeriesData)}
                                        value={this.state.resourceSearchAccessionSeries}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1,
                                                limit: "10",
                                                resourceSearchAccessionSeries: event ? [event] : [], // 👈 force array
                                                searchMultipleAccessionNumber: [],
                                                accessionSeriesWarning: ''
                                            }, () => {
                                                if (this.state.resourceSearchAccessionSeries.length > 0) {
                                                    this.getMultipleAccessionNoList();
                                                }
                                            });
                                        }}
                                        placeholder="Select Accession Series"
                                        isClearable
                                        isLoading={this.state.isFilterLoading}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42,
                                                height: 'auto',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.isFilterLoading ? "Loading..." : "No options found")}
                                        required
                                    />
                                    <p style={{ display: this.state.accessionSeriesWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionSeriesWarning}</p>
                                </div>
                            </div>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Accession Number <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={this.state.GetMultipleAccessionNumberList}
                                        onChange={(event) => {
                                            this.setState({
                                                searchMultipleAccessionNumber: event || [],
                                                accessionNumberWarning: ''
                                            })
                                        }}
                                        onInputChange={(inputValue) => {
                                            this.setState({ searchAccessionNo: inputValue }, () => {
                                                if (this.state.resourceSearchAccessionSeries?.length > 0) {
                                                    this.getMultipleAccessionNoList();
                                                }
                                            }, 200);
                                        }}
                                        isDisabled={!this.state.resourceSearchAccessionSeries || this.state.resourceSearchAccessionSeries.length === 0}
                                        value={this.state.searchMultipleAccessionNumber}
                                        isLoading={this.state.loadingAccessionNumberData}
                                        placeholder="Select Accession Number"
                                        isClearable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42,
                                                height: 'auto',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingAccessionNumberData ? "Loading..." : "No options found")}
                                        required
                                    />
                                    <p style={{ display: this.state.accessionNumberWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionNumberWarning}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* footer */}
                    <div className="modal-footer pt-5">
                        {this.state.isLoadingAddReserveBook ? <ButtonLoader /> : null}
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddMember()}>Cancel</button>
                        <button className="btn btn-primary" onClick={() => this.validateMembers()} disabled={this.state.isLoadingAddReserveBook}>Reserve A Book</button>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO UPDATE STATUS
    library_updateReserveResourceRequest = async (status) => {

        let requestData = {
            "iid": config.institute_id,
            "reserveUniqueIdArray": this.state.selectedMemberIds,
            "updatedBy": config.faculty_id || config.studentId,
            "status": status,
            "userRole": config.account
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_updateReserveResourceRequest',
            requestData,
            '/api/library/library.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_updateReserveResourceRequest()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    this.setState({
                        selectedUserIds: []
                    });
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.library_getReserveResourceRequests();

                } else {
                    this.setState({
                        selectedUserIds: []
                    });
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting list. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // METHOD TO CHECK EDIT ACCESS
    updateMembershipModal = (status) => {

        // const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['membership'].find(access => access === 'edit');

        // if (editGrantAccess !== undefined) {
        this.library_updateReserveResourceRequest(status);
        // }
        // else {
        //     this.setState({
        //         successModal: true,
        //         successModalType: 'warning',
        //         successMessage: 'This operation is restricted by the Library admin.'
        //     });
        // }
    }

    // CLEAR ALL FILTER
    handleClearAllResourceFilter = () => {
        this.setState({
            filterSelectedAccessionSeries: [], filterSelectedAccesionNumber: [], filterStatus: [], limit: 10, pageIndex: 1,
        }, () => {
            this.library_getReserveResourceRequests();
        })
    };

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
        this.setState({ dataHideWhileExporting: true })
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            exportSelectedCSVHeaders.push(csvInfo);
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    render() {
        return (
            <>
                <RoutingMenu activeScreen="reserveABook" />
                <div className="libraryComponents-container">
                    <div className="pb-5">
                        <div className='resourceHeader'>
                            <p className='vm_custom_title3' style={{ color: '#000000' }}>Reserve A Book</p>
                            <div className='d-flex col-md justify-content-end'>
                                <button type="button" onClick={() => this.checkAddMember()} style={{ fontSize: '10px !important' }} className="btn btn-primary br-5">
                                    <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;
                                    <span className='fs-13'>Reserve A Book</span>
                                </button>
                            </div>
                        </div>

                        <div>
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="taskContentRow" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                        <div className="filteredInput mb-3  p-1">
                                            <label className="fs-14 fieldHeadColor">Accession Series</label>
                                            <Select
                                                options={Object.values(this.state.AccessionSeriesData)}
                                                value={this.state.filterSelectedAccessionSeries}
                                                className="basic-multi-select-filter"
                                                onChange={(event) => {
                                                    this.setState({
                                                        pageIndex: 1,
                                                        limit: "10",
                                                        filterSelectedAccessionSeries: event ? [event] : [], // 👈 force array
                                                        filterSelectedAccesionNumber: [],
                                                    }, () => {
                                                        if (this.state.filterSelectedAccessionSeries.length > 0) {
                                                            this.getFilterMultipleAccessionNoList();
                                                        }
                                                        this.library_getReserveResourceRequests();
                                                    });
                                                }}
                                                placeholder="Select Accession Series"
                                                isLoading={this.state.loadingFilterAccessionSeriesData}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42,
                                                        height: 'auto',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => (this.state.loadingFilterAccessionSeriesData ? "Loading..." : "No options found")}
                                            />
                                        </div>

                                        <div className="filteredInput mb-3  p-1">
                                            <label className="fs-14 fieldHeadColor">Accession Number</label>
                                            <Select
                                                options={this.state.filterAccessionNumberData}
                                                onChange={(event) => {
                                                    this.setState({
                                                        filterSelectedAccesionNumber: event || [],
                                                    }, () => {
                                                        this.library_getReserveResourceRequests();
                                                    })
                                                }}
                                                onInputChange={(inputValue) => {
                                                    this.setState({ filterSearchAccessionNo: inputValue }, () => {
                                                        if (this.state.filterSelectedAccessionSeries?.length > 0) {
                                                            this.getFilterMultipleAccessionNoList();
                                                        }
                                                    }, 200);
                                                }}
                                                isDisabled={!this.state.filterSelectedAccessionSeries || this.state.filterSelectedAccessionSeries.length === 0}
                                                value={this.state.filterSelectedAccesionNumber}
                                                isLoading={this.state.loadingFilterAccessionNumberData}
                                                placeholder="Select Accession Number"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42,
                                                        height: 'auto',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => (this.state.loadingFilterAccessionNumberData ? "Loading..." : "No options found")}
                                            />
                                        </div>

                                        <div className="filteredInput mb-3  p-1">
                                            <label className="fs-14 fieldHeadColor">Status</label>
                                            <Select
                                                options={[
                                                    { label: 'Active', value: 'active' },
                                                    { label: 'Inactive', value: 'inactive' },
                                                    { label: 'Issued', value: 'issued' },
                                                    { label: 'Available', value: 'available' },
                                                    { label: 'Issued to others', value: 'issued_to_others' },
                                                    { label: 'Cancelled', value: 'cancelled' },
                                                ]}
                                                onChange={(event) => {
                                                    this.setState({
                                                        filterStatus: event || [],
                                                    }, () => {
                                                        this.library_getReserveResourceRequests();
                                                    })
                                                }}
                                                value={this.state.filterStatus}
                                                placeholder="Select Status"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42,
                                                        height: 'auto',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end align-items-center" style={{ marginTop: '15px', gap: '10px' }}>
                                        {/* Click to Print */}
                                        <div title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="resourceList"
                                                            filename="Reserve A Book List"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>

                                                    <button
                                                        onClick={() => {
                                                            this.setState({ dataHideWhileExporting: false }, () => {
                                                                this.formatCSVExportData()
                                                            })
                                                        }}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                </span>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.filterSelectedAccessionSeries.length !== 0 || this.state.pageIndex !== 1 || this.state.limit !== 10 || this.state.filterSelectedAccesionNumber.length !== 0 || this.state.filterStatus.length !== 0) &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllResourceFilter}>Clear All</p>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-md-12 px-0 div_table">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <div className="buildingReport_logo">
                                    <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                    <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                    <h3>Reserve A Book</h3>
                                </div>
                                <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                    <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                        <tr>
                                            <th className='printHide'>
                                                <input
                                                    type="checkbox"
                                                    checked={Object.keys(this.state.membersList).length > 0 && (Object.keys(this.state.membersList).length == this.state.selectedMemberIds.length)}
                                                    onChange={(e) => this.selectAllMembers(e)}
                                                    style={{ marginRight: 5 }}
                                                />
                                            </th>
                                            <th scope="col">Sr. No.</th>
                                            <th scope="col">Accession Details</th>
                                            <th scope="col">Resource Title</th>
                                            <th scope="col">Resource Author</th>
                                            {/* <th scope="col">User Details</th> */}
                                            {/* <th scope="col">Expected Date</th> */}
                                            <th scope="col">Added On</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Queue Number</th>
                                        </tr>

                                        {
                                            this.state.selectedMemberIds.length > 0 &&
                                            <tr className='printHide' style={{ backgroundColor: "#eff7ff" }}>
                                                <th colSpan="8" style={{ padding: '10px' }}>
                                                    <div className="">
                                                        <span id="renewMembership" title="Click to renew membership" onClick={() => this.updateMembershipModal("active")}>
                                                            Active
                                                        </span>
                                                        <span id="renewMembership" title="Click to renew membership" onClick={() => this.updateMembershipModal("inactive")}>
                                                            Inactive
                                                        </span>
                                                    </div>
                                                </th>
                                            </tr>
                                        }

                                    </thead>
                                    <tbody>
                                        {
                                            this.state.accessMemberList ?
                                                <tr>
                                                    <Spinner />
                                                </tr>
                                                :
                                                Object.keys(this.state.membersList).length > 0 ?
                                                    Object.values(this.state.membersList).reverse().map((members, index) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <th className='printHide'>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state.selectedMemberIds.includes(members.unique_id.toString())}
                                                                            onChange={() => this.selectSingleMember(members.unique_id.toString())}
                                                                            style={{ marginRight: 5 }}
                                                                        />
                                                                    </th>
                                                                    <td style={{ padding: '0.5rem' }}>{this.state.offset + index + 1}</td>
                                                                    <td style={{ padding: '0.5rem' }}>{members?.resourceDetails?.accession_series_text + "_" + members?.resourceDetails?.accessionnumber}</td>
                                                                    <td style={{ padding: '0.5rem' }} title={members?.resourceDetails?.title}> {
                                                                        members?.resourceDetails?.title?.length > 20
                                                                            ? members.resourceDetails.title.slice(0, 20) + "..."
                                                                            : members?.resourceDetails?.title || ""
                                                                    }</td>
                                                                    <td style={{ padding: '0.5rem' }} title={members?.resourceDetails?.author}>{
                                                                        members?.resourceDetails?.author?.length > 20
                                                                            ? members.resourceDetails.author.slice(0, 20) + "..."
                                                                            : members?.resourceDetails?.author || ""
                                                                    }</td>
                                                                    {/* <td style={{ padding: '0.5rem' }}>
                                                                        <div>
                                                                            <strong>
                                                                                User Name: {`${members?.userFirstName || ''} ${members?.userLastName || ''}`.trim()}
                                                                            </strong>
                                                                            <br />
                                                                            <strong>
                                                                                User ERP ID: {members?.userERPNo || '-'}
                                                                            </strong>
                                                                        </div>

                                                                        <div style={{ fontSize: '13px', color: '#555' }}>
                                                                            {
                                                                                members?.userRole === 'faculty'
                                                                                    ? `Employee ID: ${members?.EmployeeCode || '-'}`
                                                                                    : `PRN / University No: ${members?.userPRNNumber || '-'}`
                                                                            }
                                                                        </div>
                                                                    </td> */}
                                                                    {/* <td style={{ padding: '0.5rem' }}>{new Date(members?.available_date).toISOString().slice(0, 10)}</td> */}
                                                                    <td style={{ padding: '0.5rem' }}>{new Date(members?.added_on).toISOString().slice(0, 10)}</td>
                                                                    <td style={{ padding: '0.5rem' }}>{members?.status ? members.status.charAt(0).toUpperCase() + members.status.slice(1) : ""}</td>
                                                                    <td style={{ padding: '0.5rem' }}>{members?.queueNumber || ""}</td>
                                                                </tr>

                                                            </>
                                                        );
                                                    })
                                                    :
                                                    <tr>
                                                        <td style={{ padding: 5 }} colSpan={7}>No data found.</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {

                            (Object.keys(this.state.membersList).length > 0 || Object.keys(this.state.accessMemberList).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={(e) => this.selectLimit(e)}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalMembers}
                                                    pageRangeDisplayed={3}
                                                    onChange={(num) => this.updatePaginationCount(num)}
                                                />
                                            </div>
                                        </div>
                                        {/* {
                                                                this.returnExportAllData()
                                                            } */}
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalMembers || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </div>
                {
                    this.returnRegisterNewMember()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(ReserveABook);
